import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/index.js"

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: function(to, from, savedPosition) {
    if(to.name === "client_show") {
      return new Promise(resolve => this.app.$once('scrollAfterEnter', () => {
        if (savedPosition) {
            return resolve(savedPosition);
        }

        return resolve({ x: 0, y: 0 });
      }));
    } else {
      if (to.hash) {
        return { 
          selector: to.hash,
          offset: { x: 0, y: 64 }
        };
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("./components/Login.vue"),
      meta: {
        title: "Login"
      }
    },
    {
      path: "/reset_password",
      name: "reset_password",
      component: () => import("./components/ResetPassword.vue"),
      meta: {
        title: "Reset Password"
      }
    },
    {
      path: "/reset_password/:token",
      name: "reset_password_token",
      component: () => import("./components/ResetPasswordToken.vue"),
      meta: {
        title: "Reset Password"
      }
    },
    {
      path: "/organization_onboarding",
      name: "organization_onboarding",
      component: () =>
        import(
          "./components/OrganizationOnBoarding/OrganizationOnboarding.vue"
        ),
      meta: {
        title: "Organization Onboarding"
      }
    },
    {
      path: "/organization_landing_page",
      name: "organization_landing_page",
      component: () =>
        import(
          "./components/OrganizationOnBoarding/OrganizationLandingComponent.vue"
        )
    },
    {
      path: "/quick_books_oauth",
      name: "quick_books_oauth",
      component: () =>
        import(
          "./components/Settings/QuickbooksOnline/QuickbooksOnlineConnect.vue"
        )
    },
    {
      path: "/",
      name: "dashboard",
      component: () => import("./components/Dashboard.vue"),
      meta: {
        title: "Dashboard"
      }
    },
    {
      path: "/settings/client_onboarding/:tab?",
      name: "client_onboarding",
      component: () =>
        import("./components/Settings/ClientOnBoarding/ClientOnboarding.vue"),
      meta: {
        title: "Client Onboarding"
      }
    },
    {
      path: "/settings/quickbooks_online",
      name: "quickbooks_online",
      component: () =>
        import("./components/Settings/QuickbooksOnline/QuickbooksOnline.vue"),
      meta: {
        title: "Quickbooks Online"
      }
    },
    {
      path: "/settings/billing_settings",
      name: "billing_settings",
      component: () => import("./components/Settings/Billing/Billing.vue"),
      meta: {
        title: "Billing Settings"
      }
    },
    {
      path: "/settings/scheduler_settings",
      name: "scheduler_settings",
      component: () => import("./components/Settings/Scheduler/Scheduler.vue"),
      meta: {
        title: "Scheduler Settings"
      }
    },
    {
      path: "/settings/field_tech_app_settings",
      name: "field_tech_app_settings",
      component: () => import("./components/Settings/FieldTechApp/FieldTechApp.vue"),
      meta: {
        title: "Field Tech App Settings"
      }
    },
    {
      path: "/settings/client_portal_settings",
      name: "client_portal_settings",
      component: () => import("./components/Settings/ClientPortal/ClientPortal.vue"),
      meta: {
        title: "Client Portal Settings"
      }
    },
    {
      path: "/settings/pricing_setup",
      name: "pricing_setup",
      component: () =>
        import("./components/Settings/PricingSetup/PricingSetup.vue"),
      meta: {
        title: "Pricing Setup"
      }
    },
    {
      path: "/link_clients",
      name: "link_clients",
      component: () =>
        import("./components/Settings/QuickbooksOnline/LinkClients.vue"),
      meta: {
        title: "Link Clients"
      }
    },
    {
      path: "/settings/payroll_settings",
      name: "payroll_settings",
      component: () =>
        import("./components/Settings/Payroll/PayrollSettings.vue"),
      meta: {
        title: "Payroll Settings"
      }
    },
    {
      path: "/settings/customize_dashboard",
      name: "customize_dashboard",
      component: () =>
        import(
          "./components/Settings/CustomizeDashboard/CustomizeDashboard.vue"
        ),
      meta: {
        title: "Customize Dashboard"
      }
    },
    {
      path: "/settings/ratings_comments_and_tipping",
      name: "ratings_comments_and_tipping_settings",
      component: () =>
        import(
          "./components/Settings/RatingsCommentsAndTipping/RatingsCommentsAndTipping.vue"
        ),
      meta: {
        title: "Ratings & Comments/Tipping"
      }
    },
    {
      path: "/settings/open_api",
      name: "open_api",
      component: () =>
        import(
          "./components/Settings/OpenApi/OpenApi.vue"
        ),
      meta: {
        title: "Open API"
      }
    },
    {
      path: "/settings/royalty_payments",
      name: "royalty_payments",
      component: () =>
        import(
          "./components/Settings/RoyaltyPayments/RoyaltyPayments.vue"
        ),
      meta: {
        title: "Royalty Payments"
      }
    },
    {
      path: "/royalty_invoice/:id/show",
      name: "royalty_invoice",
      component: () =>
        import(
          "./components/Settings/RoyaltyPayments/FranchiseInvoiceShow.vue"
        ),
      meta: {
        title: "Royalty Invoice Details"
      }
    },
    {
      path: "/royalty_payment/:id/show",
      name: "royalty_payment",
      component: () =>
        import(
          "./components/Settings/RoyaltyPayments/FranchisePaymentShow.vue"
        ),
      meta: {
        title: "Royalty Payment Details"
      }
    },
    {
      path: "/settings/directory_listing",
      name: "directory_listing",
      component: () =>
        import(
          "./components/Settings/DirectoryListing/DirectoryListing.vue"
        ),
      meta: {
        title: "Directory Listing"
      }
    },
    {
      path: "/settings/subscription_details",
      name: "subscription_details",
      component: () =>
        import(
          "./components/Settings/SubscriptionDetails/SubscriptionDetails.vue"
        ),
      meta: {
        title: "Subscription Details"
      }
    },
    {
      path: "/two_factor",
      name: "two_factor",
      component: () => import("./components/Settings/TwoFactor/TwoFactor.vue"),
      meta: {
        title: "Two-factor authentication"
      }
    },
    {
      path: "/change_password",
      name: "change_password",
      component: () =>
        import("./components/Settings/ChangePassword/ChangePassword.vue"),
      meta: {
        title: "Change Password"
      }
    },
    {
      path: "/change_email",
      name: "change_email",
      component: () =>
        import("./components/Settings/ChangeEmail/ChangeEmail.vue"),
      meta: {
        title: "Change Mail"
      }
    },
    {
      path: "/change_email/:token",
      name: "change_email_token",
      component: () =>
        import("./components/Settings/ChangeEmail/ConfirmChangeEmail.vue"),
      meta: {
        title: "Change Mail"
      }
    },
    {
      path: "/settings/branding_settings",
      name: "branding_settings",
      component: () => import("./components/Settings/Branding/Branding.vue"),
      meta: {
        title: "Branding Settings"
      }
    },
    // {
    //   path: "/settings/time_and_date_settings",
    //   name: "branding_settings",
    //   component: () => import("./components/Settings/TimeAndDate/TimeAndDate.vue"),
    //   meta: {
    //     title: "Time and Date Settings"
    //   }
    // },
    {
      path: "/clients",
      name: "clients",
      component: () => import("./components/Client/ResidentialClients/Clients.vue"),
      meta: {
        title: "Client List"
      }
    },
    {
      path: "/client/:id/show",
      name: "client_show",
      component: () => import("./components/Client/ResidentialClients/ClientShow/ClientShow.vue"),
      meta: {
        title: "Client Details"
      }
    },
    {
      path: "/leads",
      name: "leads",
      component: () => import("./components/Client/ResidentialClients/Leads/Leads.vue"),
      meta: {
        title: "Leads"
      }
    },
    {
      path: "/lead/:id/show/:client_registration_id?",
      name: "lead_show",
      component: () => import("./components/Client/ResidentialClients/Leads/LeadShow.vue"),
      meta: {
        title: "Lead Details"
      }
    },
    {
      path: "/dormant_clients",
      name: "dormant_clients",
      component: () => import("./components/Client/ResidentialClients/ActuveClientsWithoutSubscription/ActuveClientsWithoutSubscription.vue"),
      meta: {
        title: "Dormant Clients"
      }
    },
    {
      path: "/commercial_clients",
      name: "commercial_clients",
      component: () => import("./components/Client/CommercialClients/CommercialClients.vue"),
      meta: {
        title: "Commercial Clients"
      }
    },
    {
      path: "/commercial_client/:id/show",
      name: "commercial_client_show",
      component: () => import("./components/Client/CommercialClients/ClientShow/ClientShow.vue"),
      meta: {
        title: "Client Details"
      }
    },
    {
      path: "/change_requests",
      name: "change_requests",
      component: () => import("./components/Client/ChangeRequests/ChangeRequests.vue"),
      meta: {
        title: "Change Requests"
      }
    },
    {
      path: "/staff",
      name: "staff",
      component: () => import("./components/Staff/StaffList/Staff.vue"),
      meta: {
        title: "Staff List"
      }
    },
    {
      path: "/staff/:id/show",
      name: "staff_show",
      component: () => import("./components/Staff/StaffList/StaffShow.vue"),
      meta: {
        title: "Staff Details"
      }
    },
    {
      path: "/my_shift_report",
      name: "my_shift_report",
      component: () =>
        import("./components/Staff/MyShiftReport/MyShiftReport.vue"),
      meta: {
        title: "My Shift Report"
      }
    },
    {
      path: "/time_mileage_report",
      name: "time_mileage_report",
      component: () =>
        import("./components/Staff/TimeAndMileage/TimeAndMileage.vue"),
      meta: {
        title: "Time & Mileage Report"
      }
    },
    {
      path: "/start_end_shift",
      name: "start_end_shift",
      component: () =>
        import("./components/Staff/StartEndShift/StartEndShift.vue"),
      meta: {
        title: "Start/End My Shift"
      }
    },
    {
      path: "/shifts",
      name: "shifts",
      component: () => import("./components/Staff/Shift/Shifts.vue"),
      meta: {
        title: "Shifts"
      }
    },
    {
      path: "/shift/:id/show",
      name: "shift",
      component: () => import("./components/Staff/Shift/ShiftItem.vue"),
      meta: {
        title: "Shift Details"
      }
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: () =>
        import("./components/Billing/Subscriptions/Subscriptions.vue"),
      meta: {
        title: "Subscriptions"
      }
    },
    {
      path: "/subscription/:id/show",
      name: "subscription",
      component: () =>
        import("./components/Billing/Subscriptions/SubscriptionShow.vue"),
      meta: {
        title: "Subscription Details"
      }
    },
    {
      path: "/commercial_subscriptions",
      name: "commercial_subscriptions",
      component: () =>
        import("./components/Billing/CommercialSubscriptions/CommercialSubscriptions.vue"),
      meta: {
        title: "Commercial Subscriptions"
      }
    },
    {
      path: "/commercial_subscription/:id/show",
      name: "commercial_subscription_show",
      component: () =>
        import("./components/Billing/CommercialSubscriptions/CommercialSubscriptionShow.vue"),
      meta: {
        title: "Subscription Details"
      }
    },
    {
      path: "/coupons",
      name: "coupons",
      component: () => import("./components/Billing/Coupons/Coupons.vue"),
      meta: {
        title: "Coupons"
      }
    },
    {
      path: "/coupon/:id/show",
      name: "coupon",
      component: () => import("./components/Billing/Coupons/CouponShow.vue"),
      meta: {
        title: "Coupon Details"
      }
    },
    {
      path: "/gift_certificates",
      name: "gift_certificates",
      component: () => import("./components/Billing/GiftCertificates/GiftCertificates.vue"),
      meta: {
        title: "Gift Certificates"
      }
    },
    {
      path: "/gift_certificate/:id/show",
      name: "gift_certificate",
      component: () => import("./components/Billing/GiftCertificates/GiftCertificateShow.vue"),
      meta: {
        title: "Gift Certificate Details"
      }
    },
    {
      path: "/payouts",
      name: "payouts",
      component: () => import("./components/Billing/Payouts/Payouts.vue"),
      meta: {
        title: "Payouts"
      }
    },
    {
      path: "/payout/:id/show",
      name: "payout",
      component: () => import("./components/Billing/Payouts/PayoutShow.vue"),
      meta: {
        title: "Payout Details"
      }
    },
    {
      path: "/one_time_invoices",
      name: "one_time_invoices",
      component: () => import("./components/Billing/Invoices/Invoices.vue"),
      meta: {
        title: "One Time Invoices"
      }
    },
    {
      path: "/recurring_invoices",
      name: "recurring_invoices",
      component: () => import("./components/Billing/Invoices/Invoices.vue"),
      meta: {
        title: "Recurring Invoices"
      }
    },
    {
      path: "/invoice/:id",
      name: "invoice",
      component: () =>
        import("./components/Billing/Invoices/InvoiceIndividualView.vue"),
      meta: {
        title: "Invoice Details"
      }
    },
    {
      path: "/invoice/:id/edit",
      name: "invoice_edit",
      component: () =>
        import("./components/Billing/Invoices/InvoiceIndividualEdit.vue"),
      meta: {
        title: "Edit Invoice"
      }
    },
    {
      path: "/payments",
      name: "payments",
      component: () => import("./components/Billing/Payments/Payments.vue"),
      meta: {
        title: "Payments"
      }
    },
    {
      path: "/payment/:id",
      name: "payment",
      component: () => import("./components/Billing/Payments/PaymentShow.vue"),
      meta: {
        title: "Payment Details"
      }
    },
    {
      path: "/receive_check_payment",
      name: "receive_check_payment",
      component: () =>
        import("./components/Billing/Payments/ReceiveCheckPayment.vue"),
      meta: {
        title: "Receive Check Payment"
      }
    },
    {
      path: "/receive_commercial_check_payment",
      name: "receive_commercial_check_payment",
      component: () =>
        import("./components/Billing/Payments/ReceiveCommercialCheckPayment.vue"),
      meta: {
        title: "Receive Commercial Check Payment"
      }
    },
    {
      path: "/dispatch_board",
      name: "dispatch_board",
      component: () =>
        import("./components/Scheduler/DispatchBoard/DispatchBoard.vue"),
      meta: {
        title: "Dispatch Board"
      }
    },
    {
      path: "/dispatch_board/:id/show",
      name: "dispatch_board_show",
      component: () =>
        import("./components/Scheduler/DispatchBoard/DispatchBoardShow.vue"),
      meta: {
        title: "Dispatch Board"
      }
    },
    {
      path: "/route_manager",
      name: "route_manager",
      component: () => import("./components/Scheduler/RouteManager.vue"),
      meta: {
        title: "Route Manager"
      }
    },
    {
      path: "/schedule",
      name: "schedule",
      component: () => import("./components/Scheduler/Schedule/Schedule.vue"),
      meta: {
        title: "Schedule"
      }
    },
    {
      path: "/schedule/:id/show",
      name: "schedule_show",
      component: () =>
        import("./components/Scheduler/Schedule/ScheduleShow.vue"),
      meta: {
        title: "Schedule Details"
      }
    },
    {
      path: "/schedule/map_view",
      name: "schedule_map_view",
      component: () => import("./components/Scheduler/MasterMap/MasterMap"),
      meta: {
        title: "Schedule"
      }
    },
    {
      path: "/unassigned",
      name: "unassigned",
      component: () =>
        import("./components/Scheduler/Unassigned/Unassigned.vue"),
      meta: {
        title: "Unassigned"
      }
    },
    {
      path: "/unassigned/:id/show",
      name: "unassigned_show",
      component: () =>
        import("./components/Scheduler/Unassigned/UnassignedShow.vue"),
      meta: {
        title: "Unassigned Details"
      }
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () => import("./components/Notifications/Notifications.vue"),
      meta: {
        title: "Notifications"
      }
    },
    {
      path: "/productivity_report",
      name: "productivity_report",
      component: () =>
        import(
          "./components/Payroll/ProductivityReport/ProductivityReport.vue"
        ),
      meta: {
        title: "Productivity Report"
      }
    },
    {
      path: "/productivity_report/:id/show/:date_from?",
      name: "productivity_report_show",
      component: () =>
        import(
          "./components/Payroll/ProductivityReport/ProductivityReportShow.vue"
        ),
      meta: {
        title: "Productivity Report Details"
      }
    },
    {
      path: "/create_pay_slips",
      name: "create_pay_slips",
      component: () =>
        import("./components/Payroll/CreatePaySlips/CreatePaySlips.vue"),
      meta: {
        title: "Create Pay Slips"
      }
    },
    {
      path: "/payroll_report",
      name: "payroll_report",
      component: () =>
        import("./components/Payroll/PayrollReport/PayrollReport.vue"),
      meta: {
        title: "Payroll Report"
      }
    },
    {
      path: "/payroll_report/:id/show/:date_from?",
      name: "payroll_report_show",
      component: () =>
        import("./components/Payroll/PayrollReport/PayrollReportShow.vue"),
      meta: {
        title: "Payroll Details"
      }
    },
    {
      path: "/connect_to_stripe",
      name: "connect_to_stripe",
      component: () =>
        import("./components/OrganizationOnBoarding/ConnectToStripe.vue"),
      meta: {
        title: "Connect To Stripe"
      }
    },
    {
      path: "/settings/residential_cross_sells",
      name: "additional_services",
      component: () =>
        import("./components/Settings/CrossSells/CrossSells.vue"),
      meta: {
        title: "Residential Cross-Sells"
      }
    },
    {
      path: "/residential_cross_sell/:id/show",
      name: "additional_service_show",
      component: () =>
        import("./components/Settings/CrossSells/CrossSellShow.vue"),
      meta: {
        title: "Residential Cross-Sell Details"
      }
    },
    {
      path: "/settings/commercial_cross_sells",
      name: "additional_commercial_services",
      component: () =>
        import("./components/Settings/CommercialCrossSells/CommercialCrossSells.vue"),
      meta: {
        title: "Commercial Cross-Sells"
      }
    },
    {
      path: "/commercial_cross_sell/:id/show",
      name: "additional_commercial_service_show",
      component: () =>
        import("./components/Settings/CommercialCrossSells/CommercialCrossSellShow.vue"),
      meta: {
        title: "Commercial Cross-Sells Details"
      }
    },
    {
      path: "/new_client_planner",
      name: "new_client_planner",
      component: () =>
        import("./components/OptimalServiceDays/NewClientPlanner.vue"),
      meta: {
        title: "New Client Planner"
      }
    },
    {
      path: "/route_planning_report",
      name: "route_planning_report",
      component: () =>
        import("./components/Reports/RoutePlanningReport/RoutePlanningReport.vue"),
      meta: {
        title: "Route Planning Report"
      }
    },
    {
      path: "/completed_jobs_report",
      name: "completed_jobs_report",
      component: () =>
        import("./components/Reports/CompletedJobsReport/CompletedJobsReport.vue"),
      meta: {
        title: "Completed Jobs Report"
      }
    },
    {
      path: "/residential_cross_sells_report",
      name: "additional_residential_services_report",
      component: () =>
        import("./components/Reports/AdditionalResidentialServicesReport/AdditionalResidentialServicesReport.vue"),
      meta: {
        title: "Residential Cross-Sells Report"
      }
    },
    {
      path: "/commercial_cross_sells_report",
      name: "additional_commercial_services_report",
      component: () =>
        import("./components/Reports/AdditionalCommercialServicesReport/AdditionalCommercialServicesReport.vue"),
      meta: {
        title: "Commercial Cross-Sells Report"
      }
    },
    {
      path: "/sales_tax_report",
      name: "sales_tax_reports",
      component: () =>
        import("./components/Billing/SalesTaxReport/SalesTaxReport.vue"),
      meta: {
        title: "Sales Tax Reports"
      }
    },
    {
      path: "/open_balance_report",
      name: "open_balance_report",
      component: () =>
        import("./components/Reports/OpenBalanceReport/OpenBalanceReport.vue"),
      meta: {
        title: "Open Balance Report"
      }
    },
    {
      path: "/cleanup_notifications_report",
      name: "cleanup_notifications_report",
      component: () =>
        import("./components/Reports/CleanupNotificationsReport/CleanupNotificationsReport.vue"),
      meta: {
        title: "Cleanup Notifications Report"
      }
    },
    {
      path: "/ratings_and_comments_report",
      name: "ratings_and_comments_report",
      component: () =>
        import("./components/Reports/RatingsAndCommentsReport/RatingsAndCommentsReport.vue"),
      meta: {
        title: "Ratings & Comments Report"
      }
    },
    {
      path: "/tips_report",
      name: "tips_report",
      component: () =>
        import("./components/Reports/TipsReport/TipsReport.vue"),
      meta: {
        title: "Tips Report"
      }
    },
    {
      path: "/work_area_activity_log",
      name: "work_area_activity_log",
      component: () =>
        import("./components/Reports/WorkAreaActivityLog/WorkAreaActivityLog.vue"),
      meta: {
        title: "Work Area Activity Log"
      }
    },
    {
      path: "/work_area/:id/show",
      name: "work_area_details",
      component: () =>
        import("./components/Reports/WorkAreaActivityLog/WorkAreaDetails/WorkAreaDetails.vue"),
      meta: {
        title: "Work Area Details"
      }
    },
    {
      path: "/work_area_inventory",
      name: "work_area_inventory",
      component: () =>
        import("./components/Reports/Inventory/Inventory.vue"),
      meta: {
        title: "Work Area Inventory"
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import("./components/Settings.vue"),
      meta: {
        title: "Settings"
      }
    },
    {
      path: "/no_premissions",
      name: "no_premissions",
      component: () => import("./components/NoPermissions.vue"),
      meta: {
        title: "No Permissions"
      }
    },
    {
      path: "*",
      name: "page_not_found",
      component: () => import("./components/PageNotFound.vue"),
      meta: {
        title: "Page Not Found"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // public/private pages redirection
  const publicPages = [
    "login",
    "reset_password",
    "reset_password_token",
    "organization_onboarding"
  ];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem("sweep_employee_token");

  if (authRequired && !loggedIn) {
    next("/login")
  } else if (!authRequired && loggedIn) {
    next("/")
  } else {
    next()
  }
});

router.beforeEach((to, from, next) => {
  // redirect to Subscription Details
  const publicPages = [
    "login",
    "reset_password",
    "reset_password_token",
    "organization_onboarding"
  ];
  const subscriptionPages = ["dashboard", "subscription_details"];
  const authRequired = !publicPages.includes(to.name);
  const subscriptionRequired = !subscriptionPages.includes(to.name);
  const isSubscribed =
    store.getters.isSubscribed || store.getters.isTrialActive;

  if (subscriptionRequired && !isSubscribed && authRequired) {
    next("/settings/subscription_details")
  } else {
    next()
  }
});

router.beforeEach((to, from, next) => {
  // If Stripe is Completed redirect to home page
  const loggedIn = localStorage.getItem("sweep_employee_token");
  const stripeCompleted = store.getters.stripeCompleted;

  if (stripeCompleted && loggedIn && to.name === "connect_to_stripe") {
    next("/")
  } else {
    next()
  }
});

router.beforeEach((to, from, next) => {
  // Permissions
  const publicPages = [
    "login",
    "reset_password",
    "reset_password_token",
    "organization_onboarding"
  ];
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem("sweep_employee_token");
  const permited = store.getters.permissions.includes(to.name);

  if (
    !permited &&
    authRequired &&
    loggedIn &&
    to.path !== "/no_premissions" &&
    to.path !== "/" &&
    to.name !== "page_not_found"
  ) {
    next("/no_premissions")
  } else {
    next()
  }
});

router.beforeEach((to, from, next) => {
  // add title
  if (to.meta.title) {
    document.title = `${to.meta.title} | Employee Portal`;
  } else {
    document.title = "Employee Portal";
  }
  next()
});

// router.onError(error => {
//     window.location.reload()
//     console.log('testing routes Env')
//     if (/loading chunk \d* failed./i.test(error.message)) {
//         console.log('testing routes')
//     }
// })

export default router;

